import React, { Component } from 'react';
import styled from 'styled-components';

import { isObject } from 'helpers';

class Image extends Component {

    constructor() {
        super();

        this.state = {
            imageElementWidth: 0
        }
    }

    componentDidMount() {
        if(!this.props.useWindowSize) this.setState({ imageElementWidth: this.refs.image.getBoundingClientRect().width });
    }

    render() {
        const { imageElementWidth } = this.state;

        let { source, image, ratio, background, minHeight, maxHeight, size, useWindowSize, backgroundPosition, className, onClick, hoverZoom, style, height, debug } = this.props;

        if(!useWindowSize && !imageElementWidth) return <div ref="image" style={{width:'100%'}} />;

        ratio = ratio ? ratio.split(':') : [16, 9];
        const perc = (100/Number(ratio[0]))*Number(ratio[1]);
        let src = '';
        let placeholder = '';

        if(!source) {
            if(!image || !image.url) return null;
            
            src = image.url;

            if(size) {
                if(size === 'extra_large') 
                    src = !isObject(image.sizes.extra_large) ? image.sizes.extra_large : image.sizes.extra_large.url;
                if(size === 'large')
                    src = !isObject(image.sizes.large) ? image.sizes.large : image.sizes.large.url;
                if(size === 'medium')
                    src = !isObject(image.sizes.large) ? image.sizes.large : image.sizes.large.url;
            } else {
                if(!useWindowSize) {
                    if(imageElementWidth > 1260) {
                        if(debug) console.log('showing extra_large based on container', debug);
                        src = !isObject(image.sizes.extra_large) ? image.sizes.extra_large : image.sizes.extra_large.url;
                    } else if(imageElementWidth > 767) {
                        if(debug) console.log('showing large based on container', debug);
                        src = !isObject(image.sizes.large) ? image.sizes.large : image.sizes.large.url;
                    } else if(imageElementWidth > 300) {
                        if(debug) console.log('showing medium based on container', debug);
                        src = !isObject(image.sizes.medium) ? image.sizes.medium : image.sizes.medium.url;
                    } else {
                        if(debug) console.log('showing thumbnail based on container', debug);
                        src = !isObject(image.sizes.thumbnail) ? image.sizes.thumbnail : image.sizes.full.url;
                    }
                } else {
                    if(window.matchMedia("(min-width: 1251px)").matches) {
                        src = !isObject(image.sizes.extra_large) ? image.sizes.extra_large : image.sizes.extra_large.url;
                    } else if(window.matchMedia("(min-width: 769px) and (max-width: 1250px)").matches) {
                        src = !isObject(image.sizes.large) ? image.sizes.large : image.sizes.large.url;
                    } else if(window.matchMedia("(max-width: 768px)").matches) {
                        src = !isObject(image.sizes.medium) ? image.sizes.medium : image.sizes.medium.url;
                    }
                }
            }

            //fallback for non existing size
            if(!src) src = !isObject(image.sizes.full) ? image.sizes.full : image.sizes.full.url;

            placeholder = !isObject(image.sizes.min) ? image.sizes.min : image.sizes.min.url;

        } else {
            src = source;
        }
        
        if(!background) {
            return (
                <img ref="image" data-src={src} className={[className, 'lazyload'].join(' ')} alt={image.alt} title={image.title} />
            )
        }
        return (
            <ImageWrapper ref="image" style={style} hoverZoom={hoverZoom} backgroundPosition={backgroundPosition} className={className} onClick={onClick} padding={perc.toFixed(2).toString()} minHeight={minHeight} maxHeight={maxHeight} height={height}>
                <div className="lazyload" data-bg={src} />
                <div className="placeholder" style={{ backgroundImage: `url(${placeholder})` }} />
            </ImageWrapper>
        )
    }
}

export default Image;

const ImageWrapper = styled.div`
    position:relative;
    padding-top: ${props => props.padding}%;
    overflow:hidden;
    background:#fff;
    width:100%;

    min-height: ${props => props.minHeight || 'auto' };

    ${props => props.height && props.height !== 'false' ? `
        padding-top:0;
        height: ${props.height}px;
        max-height: 100vh;
    ` : ``};

    ${props => props.maxHeight && props.maxHeight !== 'false' ? `
        padding-top:0;
        height: 100vh;
        max-height: ${props.maxHeight}px;
    ` : ``};

    ${props => props.hoverZoom ? `
        > div { transition: transform .7s ease-out; }
        &:hover {
            div { transform: scale(1.05); }
        }
    ` : ``}

    > div {
        position:absolute;
        top:0;
        left:0;
        bottom:0;
        right:0;
        background-size: cover;
        background-repeat:no-repeat;
        background-position: ${props => props.backgroundPosition ? props.backgroundPosition : `center center`};
        background-color: transparent!important;
        &.placeholder {
            transition: none;
            filter: blur(10px);
            top:-5px;
            left:-5px;
            bottom:-5px;
            right:-5px;
            opacity: 1;
            transition:all .2s ease-in-out;
            &:hover {
                transform: none;
            }
        }
    }
    .lazyloaded + .placeholder {
        opacity:0;
    }
`


// WEBPACK FOOTER //
// ./src/partials/Image.js